import { Box } from '@mui/material'
import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router'
import { useForm } from 'react-hook-form'
import { useUpdatePassword } from '@refinedev/core'
import { ResetPasswordHeader, InvalidTokenView, ResetPasswordForm } from './components'

type TResetPasswordFormData = {
  password: string
  confirmPassword: string
}

export const ResetPassword = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { mutate: updatePassword, isLoading } = useUpdatePassword()

  const [passwordValidation, setPasswordValidation] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    digit: false,
  })

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors, isValid },
  } = useForm<TResetPasswordFormData>({
    mode: 'onChange',
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
  })

  const watchedPassword = watch('password')

  useEffect(() => {
    const validation = {
      length: watchedPassword.length >= 8,
      uppercase: /[A-Z]/.test(watchedPassword),
      lowercase: /[a-z]/.test(watchedPassword),
      digit: /\d/.test(watchedPassword),
    }
    setPasswordValidation(validation)
  }, [watchedPassword])

  const token = searchParams.get('token')

  const onSubmit = (data: TResetPasswordFormData) => {
    if (token) {
      updatePassword({ password: data.password })
    }
  }

  const handleBackToLogin = () => {
    navigate('/login')
  }

  if (!token) {
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.paper', position: 'relative' }}>
        <ResetPasswordHeader />
        <InvalidTokenView onBackToLogin={handleBackToLogin} />
      </Box>
    )
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.paper', position: 'relative' }}>
      <ResetPasswordHeader />
      <ResetPasswordForm
        control={control}
        errors={errors}
        isValid={isValid}
        isLoading={isLoading}
        passwordValidation={passwordValidation}
        watchedPassword={watchedPassword}
        onBackToLogin={handleBackToLogin}
        onSubmit={handleSubmit(onSubmit)}
      />
    </Box>
  )
}
